import { CustomIcon } from "components/icon/customIcon.component";
import { Color } from "config/colors";
import { useTranslation } from "react-i18next";
import { Text } from "components/Typography/text.styled";
import { FontFamily, FontSize } from "config/font";
import { TopContainer } from "./topModal.styled";

type Props = {
  setClose: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  marginLeft?: number;
};

export const TopModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <TopContainer>
      <Text
        style={{ marginLeft: props.marginLeft ? props.marginLeft : 0 }}
        fontFamily={FontFamily.MontserratSemiBold}
        fontSize={FontSize.H4}
      >
        {props.title}
      </Text>
      <CustomIcon
        color={Color.DarkGrey}
        onClick={() => {
          props.setClose(false);
        }}
        name={"cross"}
        style={{ marginRight: 10, textAlign: "right", marginTop: 8 }}
      >
        {t("General.Close")}
      </CustomIcon>
    </TopContainer>
  );
};
